import { Button } from "./button";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "./dialog";
import { Icon } from "./icon";

export interface UnsavedChangesDialogProps {
  open: boolean;
  /** Called when the user confirms they want to leave (discard changes). */
  onConfirm: () => void;
  /** Called when the user decides to stay (keep changes). */
  onCancel: () => void;
  title?: string;
  description?: string;
}

/**
 * Reusable confirmation dialog for unsaved changes.
 * Pair with `useUnsavedChangesGuard` from `~/hooks/useUnsavedChangesGuard`.
 */
export const UnsavedChangesDialog = ({
  open,
  onConfirm,
  onCancel,
  title = "Unsaved Changes",
  description = "You have unsaved changes. If you leave now, your changes will be lost.",
}: UnsavedChangesDialogProps) => (
  <Dialog
    open={open}
    onOpenChange={(isOpen) => {
      if (!isOpen) {
        onCancel();
      }
    }}
  >
    <DialogContent className="max-w-sm">
      <div className="flex items-start gap-3">
        <Icon name="warning" size="lg" className="text-destructive mt-0.5 shrink-0" />
        <div className="space-y-1">
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </div>
      </div>
      <div className="flex justify-end gap-2 pt-2">
        <Button variant="outline" size="sm" onClick={onCancel}>
          Stay
        </Button>
        <Button variant="destructive" size="sm" onClick={onConfirm}>
          Leave Anyway
        </Button>
      </div>
    </DialogContent>
  </Dialog>
);
